import {
  ACR_EDIT_SET,
  ACR_SAVING_SET,
  ACR_MISC_COST_SET,
  ACR_ADDITIONAL_COST_SET,
  ACR_ADDITIONAL_COST_EDIT_SET,
  ACR_ADDITIONAL_COST_SAVING_SET,
} from 'components/admin/work-orders/details/anticipated-cost-report/store/action-types';
import { showErrorMessage } from 'actions/messages';
import { quotesApi } from 'services/api/quotes-api';
import { proposalsApi } from 'services/api/proposals-api';
import { workOrdersApi } from 'services/api/work-orders-api';
import { updateWorkOrderAttribute } from 'actions/admin/work-orders/work-orders';

export function setMiscCost(quoteId, value) {
  return (dispatch) => {
    dispatch(miscCostSet(quoteId, value));
  };
}

export function miscCostSet(quoteId, value) {
  return {
    type: ACR_MISC_COST_SET,
    payload: { quoteId: quoteId, value: value },
  };
}

export function setEdit(quoteId) {
  return (dispatch) => {
    dispatch(editSet(quoteId));
  };
}

export function editSet(quoteId) {
  return {
    type: ACR_EDIT_SET,
    payload: quoteId,
  };
}

export function savingSet(quoteId) {
  return {
    type: ACR_SAVING_SET,
    payload: quoteId,
  };
}

export function saveQuote(quoteId, values) {
  return (dispatch) => {
    dispatch(savingSet(quoteId));

    return quotesApi.updateQuote(quoteId, values).then((response) => {
      dispatch(editSet(quoteId));
      dispatch(savingSet(quoteId));

      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function setAdditionalCost(value, attr) {
  return (dispatch) => {
    dispatch(additionalCostSet(value, attr));
  };
}

export function additionalCostSet(value, attr) {
  return {
    type: ACR_ADDITIONAL_COST_SET,
    payload: { value: value, attr: attr },
  };
}

export function setAdditionalCostEdit() {
  return (dispatch) => {
    dispatch(editAdditionalCostSet());
  };
}

export function editAdditionalCostSet() {
  return {
    type: ACR_ADDITIONAL_COST_EDIT_SET,
  };
}

export function additionalCostSavingSet() {
  return {
    type: ACR_ADDITIONAL_COST_SAVING_SET,
  };
}

export function saveProposal(proposalId, values) {
  return (dispatch) => {
    dispatch(additionalCostSavingSet());

    return proposalsApi.update(proposalId, values).then((response) => {
      dispatch(editAdditionalCostSet());
      dispatch(additionalCostSavingSet());

      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function updateWorkOrderAcrDocs(workOrderId, docs, docToDestroyId) {
  return (dispatch) => {
    return workOrdersApi
      .updateWorkOrderAcrDocs(workOrderId, docs, docToDestroyId)
      .then((response) => {
        dispatch(updateWorkOrderAttribute(response.workOrder, 'acr_documents'));

        if (!response.ok) {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/anticipated-cost-report/store/actions.js